import React from 'react'
import * as Utils from 'marketing-site/src/library/utils'
import { IFooterWithCta as IContentfulFooterWithCTA } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

import {
  IProps as IFooterWithCTA,
  FooterWithCTA,
} from 'marketing-site/src/library/components/FooterWithCTA'

export const ContentfulFooterWithCTA = (footerWithCTA: IContentfulFooterWithCTA) => (
  <EntryMarker entry={footerWithCTA}>
    {() => <FooterWithCTA {...transformFooterWithCTA(footerWithCTA)} />}
  </EntryMarker>
)

function transformFooterWithCTA({ fields }: IContentfulFooterWithCTA): IFooterWithCTA {
  return {
    text: fields.text,
    bgColor: fields.bgColor ? Utils.getHexColorFromName(fields.bgColor) : undefined,
    cta: fields.cta,
  }
}
